module.exports = __webpack_public_path__ + "static/media/quizzes-action-plan.947c5ec4.svg";